import { render, staticRenderFns } from "./MessageHome.vue?vue&type=template&id=536148c3&scoped=true&"
import script from "./MessageHome.vue?vue&type=script&lang=js&"
export * from "./MessageHome.vue?vue&type=script&lang=js&"
import style0 from "./MessageHome.vue?vue&type=style&index=0&id=536148c3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536148c3",
  null
  
)

export default component.exports